export default class GeneralJS {
    constructor() {
        this.showPopupBtn = $('.js__show-popup')
        this.hidePopupBtn = $('.js__close-popup')
        this.eventListener()
        this.scrollToHash() // Check for hash on page load
    }

    eventListener() {
        this.showPopupBtn.on('click', (e) => {
            this.showPopupFnc(e)
        })

        this.hidePopupBtn.on('click', () => {
            this.hidePopupFnc()
        })

        $('.form').on('submit', (e) => {
            this.formOptions(e)
        })
    }

    showPopupFnc(e) {
        let $this = $(e.currentTarget)
        let selectedPopup = $this.data('popup')
        $('#' + selectedPopup).fadeIn()
        $('body').addClass('no-scroll')
    }

    hidePopupFnc() {
        $('.popup').fadeOut()
        $('body').removeClass('no-scroll')
    }

    formOptions(e) {
        const form = $(e.currentTarget)
        let actionUrl = form.attr('action') || window.location.pathname
        actionUrl = actionUrl.split('#')[0] + '#contact-us'
        form.attr('action', actionUrl)
    }

    scrollToHash() {
        // Check if URL has our hash
        if (window.location.hash === '#contact-us') {
            setTimeout(() => {
                $('html, body').stop().animate({
                    scrollTop: ($('.contactInfo__form').offset().top - 120)
                }, 1000)
            }, 100)
        }
    }
}